import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

const selectRegister = (state) => get('register', state);

const selectIsLoading = createSelector(selectRegister, (register) => register.isLoading);
export default selectIsLoading;
